export const ORDER_IMPORT_TYPE = Object.freeze({
  POLES: 'POLES',
  CABINETS: 'CABINETS'
});
